import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';
import CrmLayout from '../components/feature/CrmLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const PartnerLandingPage = lazy(() => import('../pages/partner-landing/page'));
const PartnerLandingViralPage = lazy(() => import('../pages/partner-landing-viral/page'));
const PartnerWebinarPage = lazy(() => import('../pages/partner-webinar/page'));
const PartnerImpressumPage = lazy(() => import('../pages/partner-impressum/page'));
const PartnerDatenschutzPage = lazy(() => import('../pages/partner-datenschutz/page'));
const CrmHome = lazy(() => import('../pages/crm/components/CrmHome'));
const CrmLeads = lazy(() => import('../pages/crm/components/CrmLeads'));
const CrmSearch = lazy(() => import('../pages/crm/components/CrmSearch'));
const CrmAffiliates = lazy(() => import('../pages/crm/components/CrmAffiliates'));
const CrmAffiliateSearch = lazy(() => import('../pages/crm/components/CrmAffiliateSearch'));
const CrmTemplates = lazy(() => import('../pages/crm/components/CrmTemplates'));
const CrmSettings = lazy(() => import('../pages/crm/components/CrmSettings'));
const CrmTraining = lazy(() => import('../pages/crm/components/CrmTraining'));
const CrmHelp = lazy(() => import('../pages/crm/components/CrmHelp'));
const CrmMarketing = lazy(() => import('../pages/crm/components/CrmMarketing'));
const CrmLinks = lazy(() => import('../pages/crm/components/CrmLinks'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const LeadDetailPage = lazy(() => import('../pages/lead-detail/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const AuthCallbackPage = lazy(() => import('../pages/auth-callback/page'));
const DebugAuthPage = lazy(() => import('../pages/debug-auth/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const TestGoogleApiPage = lazy(() => import('../pages/test-google-api/page'));
const PasswortVergessenPage = lazy(() => import('../pages/passwort-vergessen/page'));
const PasswortZuruecksetzenPage = lazy(() => import('../pages/passwort-zuruecksetzen/page'));
const SetupAdminPage = lazy(() => import('../pages/setup-admin/page'));
const ShortLinkRedirect = lazy(() => import('../pages/short-link-redirect/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/p/:slug',
    element: <PartnerLandingPage />,
  },
  {
    path: '/p/:slug/viral',
    element: <PartnerLandingViralPage />,
  },
  {
    path: '/p/:slug/webinar',
    element: <PartnerWebinarPage />,
  },
  {
    path: '/p/:slug/impressum',
    element: <PartnerImpressumPage />,
  },
  {
    path: '/p/:slug/datenschutz',
    element: <PartnerDatenschutzPage />,
  },
  {
    path: '/partner-landing',
    element: <PartnerLandingPage />,
  },
  {
    path: '/partner-landing-viral',
    element: <PartnerLandingViralPage />,
  },
  {
    path: '/partner-webinar',
    element: <PartnerWebinarPage />,
  },
  {
    path: '/go/:slug',
    element: <ShortLinkRedirect />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/registrieren',
    element: <RegisterPage />,
  },
  {
    path: '/passwort-vergessen',
    element: <PasswortVergessenPage />,
  },
  {
    path: '/passwort-zuruecksetzen',
    element: <PasswortZuruecksetzenPage />,
  },
  {
    path: '/setup-admin',
    element: <SetupAdminPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },
  {
    path: '/debug-auth',
    element: (
      <ProtectedRoute>
        <DebugAuthPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/test-google-api',
    element: <TestGoogleApiPage />,
  },
  {
    path: '/crm',
    element: <ProtectedRoute><CrmLayout /></ProtectedRoute>,
    children: [
      { index: true, element: <CrmHome /> },
      { path: 'leads', element: <CrmLeads /> },
      { path: 'lead/:id', element: <LeadDetailPage /> },
      { path: 'search', element: <CrmSearch /> },
      { path: 'links', element: <CrmLinks /> },
      { path: 'marketing', element: <CrmMarketing /> },
      { path: 'templates', element: <CrmTemplates /> },
      { path: 'affiliates', element: <CrmAffiliates /> },
      { path: 'affiliate-search', element: <CrmAffiliateSearch /> },
      { path: 'settings', element: <CrmSettings /> },
      { path: 'schulung', element: <CrmTraining /> },
      { path: 'hilfe', element: <CrmHelp /> }
    ]
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute requireAdmin={true}>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
